export default __webpack_public_path__ + "static/media/1276.63597cf4.png";